import { getUserProfile } from "../../redux/selectors/profileSelectors";
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjects, fetchProjectHistory, addProjectManagers, searchTalents, searchDepartments, updateProjectStatus } from "../../redux/actions";
import moment from "moment";
import {
  Tabs,
  Input,
  Button,
  Table,
  Dropdown,
  Menu,
  Modal,
  Select,
  DatePicker,
  Avatar,
  Tooltip,
  Drawer,
  Spin,
  Pagination,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  ControlOutlined,
  EditOutlined,
  UserAddOutlined,
  HistoryOutlined,
  MoreOutlined,
  ArrowLeftOutlined,
  CheckOutlined,
  CheckCircleOutlined,
  FilePdfOutlined,
  DeleteOutlined,
  RobotOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "./ManageProjects.css";
import {ReactComponent as ProjectIcon} from "../../assets/icons/ProjectIcon.svg";

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const AVATAR_COLORS = ["#5b8af5", "#e8a87c", "#7c5cbf", "#4aa89f", "#e05c5c", "#6abc8a"];

const getAvatarColor = (str) => {
  let hash = 0;
  for (let i = 0; i < (str || "").length; i++)
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

const getInitials = (name, email) => {
  if (name && name.trim()) {
    const parts = name.trim().split(" ").filter(Boolean);
    return parts.length >= 2
      ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      : parts[0].slice(0, 2).toUpperCase();
  }
  return (email || "??").slice(0, 2).toUpperCase();
};

function ProjectForm({ isEdit, onClose }) {
  const currencyCodeFromStore = useSelector(
    (state) => state.profileReducer?.user?.profile?.Countries?.CurrencyCode
  );
  const currencyCode = currencyCodeFromStore ||
    (() => { try { return getUserProfile()?.Profiles?.Countries?.CurrencyCode || ""; } catch { return ""; } })();
  return (
    <div className="mp-form-wrap">
      <div className="mp-form-header">
        <div className="mp-form-header-left">
          {isEdit && (
            <button className="mp-back-btn" onClick={onClose}>
              <ArrowLeftOutlined />
            </button>
          )}
          <h2 className="mp-form-title">
            {isEdit ? "Edit Project" : "Create New Project"}
          </h2>
        </div>
        {!isEdit && (
          <span className="mp-ai-link">
            <RobotOutlined style={{ marginRight: 4 }} />
            Create project through AI
          </span>
        )}
      </div>

      <div className="mp-form-body">
        <div className="mp-field-group">
          <label className="mp-label">
            Project Name <span className="mp-required">*</span>
          </label>
          <Input
            placeholder="Enter project name"
            className="mp-input"
            defaultValue={isEdit ? "Engro Branding" : ""}
          />
        </div>

        <div className="mp-field-group">
          <label className="mp-label">
            Description <span className="mp-required">*</span>
          </label>
          <TextArea
            placeholder="Enter description"
            className="mp-textarea"
            rows={4}
            maxLength={5000}
            showCount
            defaultValue={isEdit ? "Revamp the engro main branding" : ""}
          />
        </div>

        <div className="mp-field-row">
          <div className="mp-field-group mp-half">
            <label className="mp-label">
              Project Manager <span className="mp-required">*</span>
            </label>
            <Select
              placeholder="Select"
              className="mp-select"
              defaultValue={isEdit ? "james" : undefined}
            >
              <Option value="james">James William</Option>
              <Option value="bob">Bob Wilson</Option>
              <Option value="jane">Jane Doe</Option>
            </Select>
          </div>
          <div className="mp-field-group mp-half">
            <label className="mp-label">
              Department <span className="mp-required">*</span>
            </label>
            <Select
              placeholder="Select"
              className="mp-select"
              defaultValue={isEdit ? "fertilizer" : undefined}
            >
              <Option value="fertilizer">Fertilizer</Option>
              <Option value="marketing">Marketing</Option>
              <Option value="engineering">Engineering</Option>
              <Option value="finance">Finance</Option>
            </Select>
          </div>
        </div>

        <div className="mp-field-group">
          <label className="mp-label">Project Budget</label>
          <Input
            prefix={currencyCode ? <span style={{ color: '#8c8c8c', fontWeight: 500 }}>{currencyCode}</span> : null}
            placeholder="Enter Budget"
            className="mp-input"
          />
        </div>

        <div className="mp-field-row">
          <div className="mp-field-group mp-half">
            <label className="mp-label">
              Start Date <span className="mp-required">*</span>
            </label>
            <DatePicker
              className="mp-datepicker"
              placeholder="Select"
              format="DD MMM YYYY"
            />
          </div>
          <div className="mp-field-group mp-half">
            <label className="mp-label">Due Date</label>
            <DatePicker
              className="mp-datepicker"
              placeholder="Select"
              format="DD MMM YYYY"
            />
          </div>
        </div>

        <div className="mp-field-row">
          <div className="mp-field-group mp-half">
            <label className="mp-label">
              Priority <span className="mp-required">*</span>
            </label>
            <Select
              placeholder="Select"
              className="mp-select"
              defaultValue={isEdit ? "high" : undefined}
            >
              <Option value="high">High</Option>
              <Option value="medium">Medium</Option>
              <Option value="low">Low</Option>
            </Select>
          </div>
          <div className="mp-field-group mp-half">
            <label className="mp-label">
              Status <span className="mp-required">*</span>
            </label>
            <Select
              placeholder="Select"
              className="mp-select"
              defaultValue={isEdit ? "active" : undefined}
            >
              <Option value="active">Active</Option>
              <Option value="inactive">Inactive</Option>
            </Select>
          </div>
        </div>

        <div className="mp-field-group">
          <label className="mp-label">Upload Document</label>
          <div className="mp-upload-area">
            {isEdit ? (
              <div className="mp-uploaded-file">
                <FilePdfOutlined className="mp-pdf-icon" />
                <div className="mp-file-info">
                  <span className="mp-file-name">Branding.pdf</span>
                  <span className="mp-file-size">10 mb</span>
                </div>
                <DeleteOutlined className="mp-delete-icon" />
              </div>
            ) : (
              <div className="mp-upload-placeholder">
                <PlusOutlined className="mp-upload-plus" />
                <span>Click or drag file to upload</span>
              </div>
            )}
          </div>
        </div>

        <Button className="mp-submit-btn">
          {isEdit ? (
            <>
              <CheckOutlined /> Save changes
            </>
          ) : (
            "Create Project"
          )}
        </Button>
      </div>
    </div>
  );
}

function ManageProjects() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { projects, pagination, loading } = useSelector(
    (state) => state.fetchProjectsReducer
  );

  const talentDebounceRef = useRef(null);

  const [activeTab, setActiveTab] = useState("all");
  const [createVisible, setCreateVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [historyProject, setHistoryProject] = useState(null);
  const [managerProject, setManagerProject] = useState(null);
  const [addManagerOpen, setAddManagerOpen] = useState(false);
  const [selectedAccountIds, setSelectedAccountIds] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const searchDebounceRef = useRef(null);

  const { history: projectHistory, historyLoading, addManagerLoading, addManagerSuccess } = useSelector(
    (state) => state.projectDetailReducer
  );

  const engroTalents = useSelector(
    (state) => state.talentSearchReducer?.talents || []
  );
  const talentsLoading = useSelector(
    (state) => state.talentSearchReducer?.loading
  );
  const { departments, loading: deptLoading } = useSelector(
    (state) => state.departmentSearchReducer
  );
  const [filterValues, setFilterValues] = useState({
    department: null,
    projectManager: [],
    startDate: null,
    dueDate: null,
    priority: null,
    status: null,
  });
  const [appliedFilters, setAppliedFilters] = useState({});
  const [projectStatuses, setProjectStatuses] = useState({});

  const buildFilterParams = (filters, search, page = 1) => {
    const params = { page };
    if (search) params.search = search;
    if (filters.department) params.departments = filters.department;
    if (filters.projectManager?.length) params.managerAccountId = filters.projectManager.join(",");
    if (filters.startDate) params.startDate = filters.startDate.format("YYYY-MM-DD");
    if (filters.dueDate) params.dueDate = filters.dueDate.format("YYYY-MM-DD");
    if (filters.priority) params.priority = filters.priority;
    if (filters.status) params.status = filters.status;
    return params;
  };

  useEffect(() => {
    dispatch(fetchProjects());
    dispatch(searchDepartments(""));
    dispatch(searchTalents(""));
  }, []);

  useEffect(() => {
    if (addManagerSuccess) {
      setAddManagerOpen(false);
      setManagerProject(null);
      setSelectedAccountIds([]);
    }
  }, [addManagerSuccess]);

  useEffect(() => {
    if (projects && projects.length > 0) {
      const statuses = {};
      projects.forEach((p) => { statuses[p._id] = p.status; });
      setProjectStatuses(statuses);
    }
  }, [projects]);

  const tableData = (projects || []).map((p) => ({
    key: p._id,
    name: p.projectName,
    department: p.departmentName,
    managers: p.managers || [],
    jobs: p.jobsCount || 0,
    talent: p.assignedTalentCount || 0,
    startDate: p.startDate ? moment(p.startDate).format("DD MMM, YYYY") : "-",
    priority: p.priority
      ? p.priority.charAt(0).toUpperCase() + p.priority.slice(1)
      : "-",
    status: p.status,
  }));

  const handleStatusChange = (key, value) => {
    setProjectStatuses((prev) => ({ ...prev, [key]: value }));
    dispatch(updateProjectStatus(key, value));
  };

  const handleFilterReset = () => {
    const empty = { department: null, projectManager: [], startDate: null, dueDate: null, priority: null, status: null };
    setFilterValues(empty);
    setAppliedFilters({});
    setCurrentPage(1);
    dispatch(fetchProjects(buildFilterParams({}, searchText, 1)));
  };

  const handleFilterApply = () => {
    setAppliedFilters({ ...filterValues });
    setFilterVisible(false);
    setCurrentPage(1);
    dispatch(fetchProjects(buildFilterParams(filterValues, searchText, 1)));
  };

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchText(val);
    clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      setCurrentPage(1);
      dispatch(fetchProjects(buildFilterParams(appliedFilters, val, 1)));
    }, 400);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    dispatch(fetchProjects(buildFilterParams(appliedFilters, searchText, page)));
  };

  const activeFilterCount = Object.values(appliedFilters).filter((v) => (Array.isArray(v) ? v.length > 0 : Boolean(v))).length;

  const actionMenu = (record) => {
    const isLocked = record.status === "completed" || record.status === "cancelled";
    return (
      <Menu className="mp-action-menu">
        <Menu.Item
          key="edit"
          icon={<EditOutlined />}
          disabled={isLocked}
          onClick={() => !isLocked && history.push(`/manage-projects/edit/${record.key}`)}
        >
          Edit Project
        </Menu.Item>
        <Menu.Item
          key="addjob"
          icon={<PlusOutlined />}
          disabled={isLocked}
          onClick={() => !isLocked && history.push("/create-job", { projectId: record.key, projectName: record.name })}
        >
          Add Job
        </Menu.Item>
        <Menu.Item
          key="addmanager"
          icon={<UserAddOutlined />}
          disabled={isLocked}
          onClick={() => {
            if (isLocked) return;
            setManagerProject(record);
            setSelectedAccountIds([]);
          }}
        >
          Add Manager
        </Menu.Item>
        <Menu.Item
          key="history"
          icon={<HistoryOutlined />}
          onClick={() => {
            setHistoryProject(record);
            dispatch(fetchProjectHistory(record.key));
          }}
        >
          History
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "Project",
      key: "project",
      render: (_, record) => (
        <div className="mp-project-cell">
          <div className="mp-project-icon">
            <ProjectIcon />
          </div>
          <div
            className="mp-project-text"
            style={{ cursor: "pointer" }}
            onClick={() => history.push(`/manage-projects/${record.key}`)}
          >
            <div className="mp-project-name" style={{ color: "#1890ff" }}>{record.name}</div>
            <div className="mp-project-dept">{record.department}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Manager",
      key: "managers",
      render: (_, record) => (
        <Avatar.Group maxCount={2} size={30}>
          {record.managers.map((m, idx) => (
            <Tooltip
              key={idx}
              title={
                <div className="mp-avatar-tooltip">
                  {m.name && <div className="mp-tooltip-name">{m.name}</div>}
                  <div className="mp-tooltip-email">{m.email}</div>
                </div>
              }
              color="#1e1e1e"
            >
              {m.pictureUrl ? (
                <Avatar src={m.pictureUrl} size={30} />
              ) : (
                <Avatar
                  style={{
                    backgroundColor: getAvatarColor(m.email || m.name),
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                  size={30}
                >
                  {getInitials(m.name, m.email)}
                </Avatar>
              )}
            </Tooltip>
          ))}
        </Avatar.Group>
      ),
    },
    {
      title: "Jobs",
      key: "jobs",
      render: (_, record) => (
        <span className="mp-link-num">{record.jobs}</span>
      ),
    },
    {
      title: "Talent Assigned",
      key: "talent",
      render: (_, record) => (
        <span className="mp-link-num">{record.talent}</span>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (date) => <span className="mp-date-text">{date}</span>,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      render: (priority) => (
        <span className={`mp-priority mp-priority-${priority.toLowerCase()}`}>
          {priority}
        </span>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => (
        <Select
          value={projectStatuses[record.key]}
          onChange={(val) => handleStatusChange(record.key, val)}
          className={`mp-status-select mp-status-select--${(projectStatuses[record.key] || "").replace("_", "-")}`}
          bordered={false}
          dropdownClassName="mp-status-dropdown"
        >
          <Option value="new">New</Option>
          <Option value="in_progress">In Progress</Option>
          <Option value="on_hold">On Hold</Option>
          <Option value="completed">Completed</Option>
          <Option value="overdue">Overdue</Option>
          <Option value="draft">Draft</Option>
          <Option value="cancelled">Cancelled</Option>
        </Select>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown
          overlay={actionMenu(record)}
          trigger={["click"]}
          placement="bottomRight"
          overlayClassName="mp-action-dropdown"
        >
          <MoreOutlined className="mp-more-icon" />
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      <div className="mp-page">
        <div className="mp-top-bar">
          <h1 className="mp-page-title">Manage Projects</h1>
          <Button
            className="mp-create-btn"
            icon={<PlusOutlined />}
            onClick={() => history.push("/manage-projects/create")}
          >
            Create New Project
          </Button>
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="mp-tabs"
        >
          <TabPane tab={`All Projects (${pagination?.total || 0})`} key="all">
            <div className="mp-toolbar">
              <Input
                placeholder="Search projects"
                prefix={<SearchOutlined className="mp-search-icon" />}
                className="mp-search"
                allowClear
                value={searchText}
                onChange={handleSearchChange}
              />
              <span style={{ position: 'relative', display: 'inline-flex' }}>
                <Button
                  icon={<ControlOutlined />}
                  className="mp-filter-btn"
                  onClick={() => setFilterVisible(true)}
                >
                  Filters
                </Button>
                {activeFilterCount > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '-7px',
                    right: '-7px',
                    background: '#1890ff',
                    color: '#fff',
                    fontSize: '11px',
                    fontWeight: 700,
                    borderRadius: '50%',
                    width: '17px',
                    height: '17px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                    pointerEvents: 'none',
                  }}>{activeFilterCount}</span>
                )}
              </span>
            </div>
            <Table
              columns={columns}
              dataSource={tableData}
              loading={loading}
              pagination={false}
              className="mp-table"
              rowClassName={(record) =>
                `mp-table-row${record.status === "completed" || record.status === "cancelled" ? " mp-row-locked" : ""}`
              }
              locale={{
                emptyText: (
                  <div className="mp-empty-state">
                    <div className="mp-empty-icon">📋</div>
                    <p className="mp-empty-title">No Projects Found</p>
                    <p className="mp-empty-sub">Create your first project to get started</p>
                    <Button
                      className="mp-create-btn"
                      icon={<PlusOutlined />}
                      onClick={() => history.push("/manage-projects/create")}
                    >
                      Create New Project
                    </Button>
                  </div>
                ),
              }}
            />
            {pagination?.total > 0 && (
              <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
                <Pagination
                  current={currentPage}
                  total={pagination.total}
                  pageSize={pagination.perPage || 10}
                  onChange={handlePageChange}
                  showSizeChanger={false}

                />
              </div>
            )}
          </TabPane>

        </Tabs>
      </div>

      <Drawer
        title={
          <div className="mp-fd-header">
            <span className="mp-fd-title">Filter</span>
            <CloseOutlined className="mp-fd-close" onClick={() => setFilterVisible(false)} />
          </div>
        }
        placement="right"
        width={560}
        closable={false}
        open={filterVisible}
        onClose={() => setFilterVisible(false)}
        className="mp-filter-drawer"
        bodyStyle={{ padding: "20px", overflowY: "auto" }}
        footer={
          <div className="mp-fd-footer">
            <button className="mp-fd-reset-btn" onClick={handleFilterReset}>
              Reset
            </button>
            <button className="mp-fd-apply-btn" onClick={handleFilterApply}>
              Apply Filter
            </button>
          </div>
        }
        footerStyle={{ padding: "16px 20px", borderTop: "1px solid #f0f0f0" }}
      >
        <div className="mp-fd-field-group">
          <label className="mp-fd-label">Department</label>
          <Select
            placeholder="Select"
            className="mp-fd-select"
            value={filterValues.department}
            onChange={(val) => setFilterValues((p) => ({ ...p, department: val }))}
            loading={deptLoading}
            allowClear
            showSearch
            filterOption={false}
            onSearch={(val) => dispatch(searchDepartments(val))}
            notFoundContent={null}
          >
            {(Array.isArray(departments) ? departments : []).map((dept) => (
              <Option key={dept._id} value={dept._id}>
                {dept.DepartmentName}
              </Option>
            ))}
          </Select>
        </div>

        <div className="mp-fd-field-group">
          <label className="mp-fd-label">Project Manager</label>
          <Select
            mode="multiple"
            placeholder="Select"
            className="mp-fd-select mp-fd-select-multi"
            value={filterValues.projectManager}
            onChange={(val) => setFilterValues((p) => ({ ...p, projectManager: val }))}
            loading={talentsLoading}
            allowClear
            showSearch
            filterOption={false}
            onSearch={(val) => {
              if (talentDebounceRef.current) clearTimeout(talentDebounceRef.current);
              talentDebounceRef.current = setTimeout(() => dispatch(searchTalents(val || "")), 300);
            }}
            onDropdownVisibleChange={(open) => { if (open) dispatch(searchTalents("")); }}
            optionLabelProp="label"
            notFoundContent={talentsLoading ? "Searching..." : "No results found"}
          >
            {(Array.isArray(engroTalents) ? engroTalents : []).map((talent) => (
              <Option key={talent.accountId} value={talent.accountId} label={talent.FullName || talent.EmailAddress || ""}>
                <div>
                  <span>{talent.FullName || talent.EmailAddress}</span>
                  <span style={{ fontSize: '11px', color: '#888', display: 'block' }}>
                    {talent.professionalRoleName ? `(${talent.professionalRoleName})` : talent.EmailAddress}
                  </span>
                </div>
              </Option>
            ))}
          </Select>
        </div>

        <div className="mp-fd-field-group">
          <label className="mp-fd-label">Start Date</label>
          <DatePicker
            className="mp-fd-datepicker"
            placeholder="Select"
            format="DD MMM YYYY"
            value={filterValues.startDate}
            onChange={(val) => setFilterValues((p) => ({ ...p, startDate: val }))}
          />
        </div>

        <div className="mp-fd-field-group">
          <label className="mp-fd-label">Due Date</label>
          <DatePicker
            className="mp-fd-datepicker"
            placeholder="Select"
            format="DD MMM YYYY"
            value={filterValues.dueDate}
            onChange={(val) => setFilterValues((p) => ({ ...p, dueDate: val }))}
          />
        </div>

        <div className="mp-fd-field-group">
          <label className="mp-fd-label">Priority</label>
          <Select
            placeholder="Select"
            className="mp-fd-select"
            value={filterValues.priority}
            onChange={(val) => setFilterValues((p) => ({ ...p, priority: val }))}
            allowClear
          >
            <Option value="High">High</Option>
            <Option value="Medium">Medium</Option>
            <Option value="Low">Low</Option>
          </Select>
        </div>

        <div className="mp-fd-field-group">
          <label className="mp-fd-label">Status</label>
          <Select
            placeholder="Select"
            className="mp-fd-select"
            value={filterValues.status}
            onChange={(val) => setFilterValues((p) => ({ ...p, status: val }))}
            allowClear
          >
            <Option value="new">New</Option>
            <Option value="in_progress">In Progress</Option>
            <Option value="on_hold">On Hold</Option>
            <Option value="completed">Completed</Option>
            <Option value="overdue">Overdue</Option>
            <Option value="draft">Draft</Option>
            <Option value="cancelled">Cancelled</Option>
          </Select>
        </div>
      </Drawer>

      <Modal
        visible={createVisible}
        onCancel={() => setCreateVisible(false)}
        footer={null}
        width={540}
        className="mp-modal"
        destroyOnClose
        closeIcon={null}
      >
        <ProjectForm isEdit={false} onClose={() => setCreateVisible(false)} />
      </Modal>

      <Modal
        visible={editVisible}
        onCancel={() => setEditVisible(false)}
        footer={null}
        width={540}
        className="mp-modal"
        destroyOnClose
        closeIcon={null}
      >
        <ProjectForm isEdit={true} onClose={() => setEditVisible(false)} />
      </Modal>

      {/* Modal 1 — existing managers list */}
      <Modal
        visible={!!managerProject && !addManagerOpen}
        onCancel={() => { setManagerProject(null); setSelectedAccountIds([]); }}
        footer={null}
        width={580}
        className="mp-manager-modal"
        destroyOnClose
      >
        <div className="mp-manager-wrap">
          <div className="mp-manager-header">
            <span className="mp-manager-title">Manager</span>
          </div>

          <div className="mp-manager-project-card">
            <div className="mp-manager-project-icon">
              <ProjectIcon/>
            </div>
            <div className="mp-manager-project-info">
              <div className="mp-manager-project-name">{managerProject?.name}</div>
              <div className="mp-manager-project-dept">{managerProject?.department || "Department name"}</div>
            </div>
          </div>

          {(managerProject?.managers || []).length === 0 ? (
            <div className="mp-manager-empty">No managers assigned yet.</div>
          ) : (
            <div className="mp-manager-list">
              {(managerProject?.managers || []).map((manager, idx) => {
                const name = manager?.name || "—";
                const email = manager?.email || "—";
                const initials = (name !== "—" ? name : email).slice(0, 2).toUpperCase();
                return (
                  <div key={idx} className="mp-manager-row">
                    {manager?.pictureUrl ? (
                      <img src={manager.pictureUrl} alt={name} className="mp-manager-avatar" />
                    ) : (
                      <div className="mp-manager-avatar mp-manager-avatar-fallback">{initials}</div>
                    )}
                    <div className="mp-manager-info">
                      <div className="mp-manager-name">{name || email}</div>
                      <div className="mp-manager-email">{email}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <button
            className="mp-manager-add-btn"
            onClick={() => { setSelectedAccountIds([]); setAddManagerOpen(true); dispatch(searchTalents("")); }}
          >
            <PlusOutlined /> Add Manager
          </button>
        </div>
      </Modal>

      {/* Modal 2 — add manager form */}
      <Modal
        visible={addManagerOpen}
        onCancel={() => { setAddManagerOpen(false); setSelectedAccountIds([]); }}
        footer={null}
        width={540}
        className="mp-manager-modal"
        destroyOnClose
      >
        <div className="mp-manager-wrap">
          <div className="mp-manager-header">
            <span className="mp-manager-title">Add Manager</span>
          </div>

          <div className="mp-manager-project-card">
            <div className="mp-manager-project-icon">
              <ProjectIcon/>
            </div>
            <div className="mp-manager-project-info">
              <div className="mp-manager-project-name">{managerProject?.name}</div>
              <div className="mp-manager-project-dept">{managerProject?.department || "Department name"}</div>
            </div>
          </div>

          <div className="mp-manager-field">
            <label className="mp-manager-label">Manager</label>
            <Select
              mode="multiple"
              placeholder="Select"
              className="mp-manager-select"
              loading={talentsLoading}
              value={selectedAccountIds}
              onChange={(vals) => setSelectedAccountIds(vals)}
              optionFilterProp="label"
              style={{ width: "100%" }}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {(engroTalents || []).map((talent, idx) => {
                const label = `${talent?.FullName || talent?.EmailAddress || "—"}${talent?.professionalRoleName ? ` (${talent.professionalRoleName})` : ""}`;
                return (
                  <Option key={String(idx)} value={talent?.accountId} label={label}>
                    {label}
                  </Option>
                );
              })}
            </Select>
          </div>

          <button
            className="mp-manager-add-btn"
            disabled={addManagerLoading || selectedAccountIds.length === 0}
            onClick={() => {
              const existingIds = (managerProject?.managers || []).map((m) => m.accountId).filter(Boolean);
              const allIds = [...new Set([...existingIds, ...selectedAccountIds])];
              dispatch(addProjectManagers(managerProject?.key, allIds));
            }}
          >
            <CheckCircleOutlined /> Save changes
          </button>
        </div>
      </Modal>

      <Modal
        visible={!!historyProject}
        onCancel={() => setHistoryProject(null)}
        footer={null}
        width={560}
        className="mp-modal mp-history-modal"
        destroyOnClose
      >
        <div className="mp-history-wrap">
          <h2 className="mp-history-title">Project History</h2>
          <div className="mp-history-divider" />
          <div className="mp-history-project-card">
            <div className="mp-history-project-icon">
              <svg width="28" height="28" viewBox="0 0 34 34" fill="none">
                <rect width="34" height="34" rx="6" fill="#e8f4fd" />
                <path
                  d="M17 8L9 12V20C9 24.42 12.55 28.57 17 29.6C21.45 28.57 25 24.42 25 20V12L17 8Z"
                  fill="#1890ff" opacity="0.2"
                />
                <path
                  d="M17 8L9 12V20C9 24.42 12.55 28.57 17 29.6C21.45 28.57 25 24.42 25 20V12L17 8Z"
                  stroke="#1890ff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="mp-history-project-info">
              <div className="mp-history-project-name">{historyProject?.name}</div>
              <div className="mp-history-project-dept">{historyProject?.department}</div>
            </div>
            {historyProject?.status && (
              <span className={`mp-history-status mp-history-status-${(historyProject.status || "").toLowerCase().replace(/\s/g, "-")}`}>
                {historyProject.status}
              </span>
            )}
          </div>

          {historyLoading ? (
            <div className="mp-history-loading"><Spin /></div>
          ) : (projectHistory || []).length === 0 ? (
            <div className="mp-history-empty">No history available.</div>
          ) : (
            <div className="mp-history-timeline">
              {(projectHistory || []).map((item, idx) => (
                <div key={idx} className="mp-history-item">
                  <div className="mp-history-dot" />
                  {idx < projectHistory.length - 1 && <div className="mp-history-line" />}
                  <div className="mp-history-content">
                    <div className="mp-history-action">{item.title}</div>
                    <div className="mp-history-meta">
                      {item.changedAt
                        ? moment().diff(moment(item.changedAt), "days") < 7
                          ? moment(item.changedAt).fromNow()
                          : moment(item.changedAt).format("DD MMMM YYYY")
                        : ""}
                      {item.changedBy?.email ? ` by ${item.changedBy.email}` : ""}
                    </div>
                    {item.message && (
                      <div className="mp-history-desc">{item.message}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}

export default ManageProjects;
